import { Routes, Route } from "react-router-dom";

// Inventory Components
import ProductList from "../components/pages/AdminPannel/products/ProductList";
import ProductDetail from "../components/pages/AdminPannel/products/ProductDetail";
import AddProductForm from "../components/pages/AdminPannel/products/AddProductForm";
import Collection from "../components/pages/AdminPannel/collection/Collection";
import CollectionForm from "../components/pages/AdminPannel/collection/CollectionForm";
import CollectionDetail from "../components/pages/AdminPannel/collection/CollectionDetail";
import ShadesList from "../components/pages/AdminPannel/shades/ShadesList";
import ShadesForm from "../components/pages/AdminPannel/shades/ShadesForm";
import ShadesDetail from "../components/pages/AdminPannel/shades/ShadesDetail";
import Shade from "../components/pages/AdminPannel/shades/Shade";
import ProductReviewList from "../components/pages/AdminPannel/productReview/ProductReviewList";
import PermissionProtectedRoute from "../components/router/ProtectedRoute";
import RawMaterialForm from "../components/pages/AdminPannel/inventory/rawMaterial/RawMaterialForm";
import RawMaterialDetail from "../components/pages/AdminPannel/inventory/rawMaterial/RawMaterialDetail";
import RawMaterialList from "../components/pages/AdminPannel/inventory/rawMaterial/RawMaterialList";
import BOMList from "../components/pages/AdminPannel/bom/BOMList";
import BOMForm from "../components/pages/AdminPannel/bom/BOMForm";
import BOMDetail from "../components/pages/AdminPannel/bom/BOMDetail";

const InventoryRoutes = () => {
  return (
    <Routes>
      {/* Product Routes */}
      <Route path="product-list" element={
        <PermissionProtectedRoute moduleName="Item" action="viewOnly">
          <ProductList />
        </PermissionProtectedRoute>
      } />
      <Route path="product-detail" element={
        <PermissionProtectedRoute moduleName="Item" action="viewAll">
          <ProductDetail />
        </PermissionProtectedRoute>
      } />
      <Route path="add-product-form" element={
        <PermissionProtectedRoute moduleName="Item" action="add">
          <AddProductForm />
        </PermissionProtectedRoute>
      } />
      <Route path="update-product-form" element={
        <PermissionProtectedRoute moduleName="Item" action="edit">
          <AddProductForm />
        </PermissionProtectedRoute>
      } />

      {/* Collection Routes */}
      <Route path="collection" element={
        <PermissionProtectedRoute moduleName="category" action="viewOnly">
          <Collection />
        </PermissionProtectedRoute>
      } />
      <Route path="collection-form" element={
        <PermissionProtectedRoute moduleName="category" action="add">
          <CollectionForm />
        </PermissionProtectedRoute>
      } />
      <Route path="collection-detail" element={
        <PermissionProtectedRoute moduleName="category" action="viewAll">
          <CollectionDetail />
        </PermissionProtectedRoute>
      } />

      {/* Shades Routes */}
      <Route path="shade-list" element={
        <PermissionProtectedRoute moduleName="Shade" action="viewOnly">
          <ShadesList />
        </PermissionProtectedRoute>
      } />
      <Route path="shade-form" element={
        <PermissionProtectedRoute moduleName="Shade" action="add">
          <ShadesForm />
        </PermissionProtectedRoute>
      } />
      <Route path="shade-form-update" element={
        <PermissionProtectedRoute moduleName="Shade" action="edit">
          <ShadesForm />
        </PermissionProtectedRoute>
      } />
      <Route path="shade-detail" element={
        <PermissionProtectedRoute moduleName="Shade" action="viewAll">
          <Shade />
        </PermissionProtectedRoute>
      } />
      {/* Raw Material Routes */}
       <Route path="raw-material-list" element={
        <PermissionProtectedRoute moduleName="Raw Material" action="viewOnly">
          <RawMaterialList />
        </PermissionProtectedRoute>
      } />
      <Route path="raw-material-form" element={
        <PermissionProtectedRoute moduleName="Raw Material" action="add">
          <RawMaterialForm />
        </PermissionProtectedRoute>
      } />
      <Route path="raw-material-form-update" element={
        <PermissionProtectedRoute moduleName="Raw Material" action="edit">
          <RawMaterialForm/>
        </PermissionProtectedRoute>
      } />
      <Route path="raw-material-detail" element={
        <PermissionProtectedRoute moduleName="Raw Material" action="viewAll">
          <RawMaterialDetail />
        </PermissionProtectedRoute>
      } />

      
      {/* BOM */}
      <Route path="bom-list" element={
        <PermissionProtectedRoute moduleName="Bom" action="viewOnly">
          <BOMList />
        </PermissionProtectedRoute>
      } />
      <Route path="bom-form" element={
        <PermissionProtectedRoute moduleName="Bom" action="add">
          <BOMForm />
        </PermissionProtectedRoute>
      } />
      <Route path="update-bom-form/:id" element={
        <PermissionProtectedRoute moduleName="Bom" action="edit">
          <BOMForm />
        </PermissionProtectedRoute>
      } />
      <Route path="bom-detail/:id" element={
        <PermissionProtectedRoute moduleName="Bom" action="viewAll">
          <BOMDetail />
        </PermissionProtectedRoute>
      } />

      {/* Product Review */}
      <Route path="product-review" element={
        <PermissionProtectedRoute moduleName="Product Review" action="viewOnly">
          <ProductReviewList />
        </PermissionProtectedRoute>
      } />
    </Routes>
  );
};

export default InventoryRoutes;

